module.exports = __webpack_public_path__ + "img/lecture_qualite_vie.6a1d7a0d.png";